<template>
    <div class="chat-input-section">

        <div class="reply-preview-wrapper" v-if="messageToReply && !isForwarding" @click="uiStore.scrollToMessage(messageToReply.id)">
            <div class="reply-content">
                <i class="ri-reply-line reply-icon"></i>
                <div class="reply-text">
                    <div class="reply-owner">{{ messageToReply.replyOwner || (messageToReply.isSent ? (messageToReply.idUsuarioSender == authStore.user?.id ? 'Você' : messageToReply.agentName) || 'Você' : getSenderName(messageToReply.idContatoSender || messageToReply.idUsuarioSender)) }}</div>
                    <div class="reply-snippet">
                        <i v-if="GetReplyIconFromType(messageToReply.type)" :class="GetReplyIconFromType(messageToReply.type, messageToReply.fileData)"></i>
                        {{ getReplySnippet(messageToReply) }}
                    </div>
                </div>
            </div>
            <template v-if="['imagem','video'].includes(messageToReply.type ?? '')">
                <div v-if="messageToReply.type == 'imagem' && messageToReply.fileData?.url" class="ms-auto reply-media-content-preview">
                    <img :src="messageToReply.fileData?.url" style="object-fit: cover;" class="ms-auto reply-media-content-preview">
                </div>
                <div v-else-if="messageToReply.type == 'video' && messageToReply.fileData?.url" class="ms-auto reply-media-content-preview">
                    <VideoDeChat :src="messageToReply.fileData?.url" style="object-fit: cover;" class="reply-media-content-preview"></VideoDeChat>
                </div>
            </template>
            <button type="button" class="btn icon-btn btn-close-reply" title="Cancelar Resposta" @click.stop="closeReplyPreview()">
                <i class="ri-close-line"></i>
            </button>
        </div>

        <!-- "Responder em particular": a mensagem veio de um GRUPO, então não há onde
             rolar nesta conversa — sem o clique de "ir até a mensagem". -->
        <div class="reply-preview-wrapper private-reply-preview"
            v-if="respostaParticular && !messageToReply && !messageToEdit && !isForwarding"
            role="group" :aria-label="`Respondendo em particular a ${respostaParticular.nomeRemetente}, do grupo ${respostaParticular.nomeGrupo}`">
            <div class="reply-content">
                <i class="ri-chat-private-line reply-icon" aria-hidden="true"></i>
                <div class="reply-text">
                    <div class="private-reply-header">
                        <span class="reply-owner text-truncate">{{ respostaParticular.nomeRemetente }}</span>
                        <span class="private-reply-origin" :title="respostaParticular.nomeGrupo">
                            <i class="ri-group-line" aria-hidden="true"></i>
                            <span class="text-truncate">{{ respostaParticular.nomeGrupo }}</span>
                        </span>
                        <i class="ri-information-line private-reply-hint" tabindex="0" role="note"
                            aria-label="O contato recebe a sua resposta citando esta mensagem do grupo, como no “Responder em particular” do WhatsApp."
                            v-tooltip="'O contato recebe a sua resposta citando esta mensagem do grupo, como no “Responder em particular” do WhatsApp.'"></i>
                    </div>
                    <div class="reply-snippet">
                        <i v-if="GetReplyIconFromType(respostaParticular.mensagem.type)" :class="GetReplyIconFromType(respostaParticular.mensagem.type, respostaParticular.mensagem.fileData)"></i>
                        {{ getReplySnippet(respostaParticular.mensagem) }}
                    </div>
                </div>
            </div>
            <template v-if="['imagem','video'].includes(respostaParticular.mensagem.type ?? '')">
                <div v-if="respostaParticular.mensagem.type == 'imagem' && respostaParticular.mensagem.fileData?.url" class="ms-auto reply-media-content-preview">
                    <img :src="respostaParticular.mensagem.fileData?.url" alt="" style="object-fit: cover;" class="ms-auto reply-media-content-preview">
                </div>
                <div v-else-if="respostaParticular.mensagem.type == 'video' && respostaParticular.mensagem.fileData?.url" class="ms-auto reply-media-content-preview">
                    <VideoDeChat :src="respostaParticular.mensagem.fileData?.url" style="object-fit: cover;" class="reply-media-content-preview"></VideoDeChat>
                </div>
            </template>
            <button type="button" class="btn icon-btn btn-close-reply" title="Cancelar resposta em particular"
                aria-label="Cancelar resposta em particular" @click.stop="cancelarRespostaParticular()">
                <i class="ri-close-line" aria-hidden="true"></i>
            </button>
        </div>

        <div class="reply-preview-wrapper edit-preview" v-if="messageToEdit && !isForwarding" @click="uiStore.scrollToMessage(messageToEdit.id)">
            <div class="reply-content">
                <i class="ri-pencil-line reply-icon"></i>
                <div class="reply-text">
                    <div class="reply-owner">Editando mensagem</div>
                    <div class="reply-snippet">
                        <i v-if="GetReplyIconFromType(messageToEdit.type)" :class="GetReplyIconFromType(messageToEdit.type, messageToEdit.fileData)"></i>
                        {{ getReplySnippet(messageToEdit) }}
                    </div>
                </div>
            </div>
            <template v-if="['imagem','video'].includes(messageToEdit.type ?? '')">
                <div v-if="messageToEdit.type == 'imagem' && messageToEdit.fileData?.url" class="ms-auto reply-media-content-preview">
                    <img :src="messageToEdit.fileData?.url" style="object-fit: cover;" class="ms-auto reply-media-content-preview">
                </div>
                <div v-else-if="messageToEdit.type == 'video' && messageToEdit.url" class="ms-auto reply-media-content-preview">
                    <VideoDeChat :src="messageToEdit.fileData?.url" style="object-fit: cover;" class="reply-media-content-preview"></VideoDeChat>
                </div>
            </template>
            <button type="button" class="btn icon-btn btn-close-reply" title="Cancelar Edição" @click.stop="closeEditPreview()">
                <i class="ri-close-line"></i>
            </button>
        </div>

        <template v-if="!isForwarding">
            <div v-if="showMentionList" class="mention-dropdown-container">
                <div class="mention-list">
                    <div
                        v-for="(participant, index) in filteredParticipants"
                        :key="index"
                        class="mention-item"
                        :class="{ 'active': index === selectedMentionIndex }"
                        @click.stop.prevent="selectParticipant(participant)"
                    >
                        <div class="mention-avatar">
                            <img v-if="participant.avatar" :src="participant.avatar" alt="">
                            <span v-else class="initials">{{ getInitials(participant.name) }}</span>
                        </div>
                        <div class="mention-info">
                            <span class="mention-name">
                                {{ participant.name }}
                                <i v-if="participant.isAdmin" class="ri-vip-crown-fill text-warning ms-1 font-size-10"></i>
                            </span>
                            <span v-if="participant.phone" class="mention-phone">{{ participant.phone }}</span>
                        </div>
                    </div>
                    <div v-if="filteredParticipants.length === 0" class="mention-empty">
                        Nenhum participante encontrado
                    </div>
                </div>
            </div>

            <!-- Desconexão PRIMEIRO: é o bloqueio mais forte e o único acionável (leva ao
                 QR Code). Com as tarjas de grupo na frente, um membro comum de grupo
                 announce com a instância caída via "Somente Administradores" e nunca
                 descobria que precisava reconectar. -->
            <div v-if="linkedInboxIsOffline && !isTeamMode" class="offline-status-container" @click="funcaoQrcode">
                <div class="offline-content">
                    <div class="offline-icon-pulse">
                        <i class="ri-plug-2-line"></i>
                    </div>
                    <div class="offline-text">
                        <strong>Conexão Perdida</strong>
                        <span>Sua instância está desconectada. Clique aqui para ler o QR Code e retomar o atendimento.</span>
                    </div>
                </div>
                <button class="btn btn-reconnect" @click.stop="funcaoQrcode">
                    <i class="ri-qr-code-line"></i> Reconectar
                </button>
            </div>
            <div v-else-if="isGroupAnnounceAndInboxIsNotAdmin" class="offline-status-container">
                <div class="offline-content">
                    <div class="offline-icon-pulse">
                        <i class="ri-megaphone-line"></i>
                    </div>
                    <div class="offline-text">
                        <strong>Somente Administradores</strong>
                        <span>Neste grupo apenas administradores podem enviar mensagens, e este inbox não é administrador. Se o número foi removido do grupo, o aviso é o mesmo — a lista de participantes de um grupo de avisos não permite distinguir os dois casos.</span>
                    </div>
                </div>
            </div>
            <div v-else-if="isGroupAndInboxIsNonParticipating" class="offline-status-container">
                <div class="offline-content">
                    <div class="offline-icon-pulse">
                        <i class="ri-user-forbid-line"></i>
                    </div>
                    <div class="offline-text">
                        <strong>Inbox Fora do Grupo</strong>
                        <span>O número desse inbox não é um participante do grupo. Para mandar e receber mensagens, adicione-o novamente.</span>
                    </div>
                </div>
            </div>

            <!-- 🤖 Caso em que o chat está controlado por um chatbot de IA -->
            <div v-else-if="chatIsControlledByAI" class="ai-status-container"
                 :class="{ 'is-bloqueado': !podeInterromperIa }"
                 @click="podeInterromperIa && interromperIa(chatStore.activeChat!)">
                <div class="ai-content">
                    <div class="ai-icon-pulse">
                        <i class="ri-robot-3-line"></i>
                    </div>
                    <div class="ai-text">
                        <strong>Atendimento controlado por IA</strong>
                        <span v-if="podeInterromperIa">Um atendente de IA está nesse chat. Clique aqui para interrompê-lo e iniciar o atendimento manual.</span>
                        <span v-else>Um atendente de IA está nesse chat. Você não tem permissão para interrompê-lo.</span>
                    </div>
                </div>
                <button class="btn btn-interrupt" @click.stop="interromperIa(chatStore.activeChat!)" :disabled="interrompendoBotIa || !podeInterromperIa">
                    <template v-if="interrompendoBotIa">
                        <i class="ri-loader-3-line fw-normal spin"></i> Interromper
                    </template>
                    <template v-else>
                        <i class="ri-stop-circle-line fw-normal"></i> Interromper
                    </template>
                </button>
            </div>

            <!-- 🤖 Caso em que o chat está controlado por um bot normal -->
            <div v-else-if="chatIsControlledByBot" class="bot-status-container" @click="interromperBot(chatStore.activeChat!)">
                <div class="bot-content">
                    <div class="bot-icon-pulse">
                        <i class="ri-robot-3-line"></i>
                    </div>
                    <div class="bot-text">
                        <strong>Atendimento controlado por Bot</strong>
                        <span>Um bot está gerenciando esse chat. Clique aqui para interrompê-lo e abrir o atendimento.</span>
                    </div>
                </div>
                <button class="btn btn-start-attendance" @click.stop="interromperBot(chatStore.activeChat!)" :disabled="interrompendoBot">
                    <template v-if="interrompendoBot">
                        <i class="ri-loader-3-line fw-normal spin"></i> Abrindo...
                    </template>
                    <template v-else>
                        <i class="ri-play-fill fw-normal"></i> Abrir atendimento
                    </template>
                </button>
            </div>

            <!-- 🤖 Caso em que o chat está controlado por um chatbot de IA -->
            <div v-else-if="chatIsOpenButAtendimentoIsNotOpen" class="ciobaino-status-container" @click="abrirAtendimento(chatStore.activeChat!)">
                <div class="ciobaino-content">
                    <div class="ciobaino-icon-pulse">
                        <i class="ri-robot-3-line"></i>
                    </div>
                    <div class="ciobaino-text">
                        <strong>Abrir atendimento</strong>
                        <span>Esse atendimento ainda não foi aberto. Clique aqui para abri-lo e poder enviar mensagens.</span>
                    </div>
                </div>
                <button class="btn btn-open" @click.stop="abrirAtendimento(chatStore.activeChat!)" :disabled="abrindoAtendimento">
                    <template v-if="abrindoAtendimento">
                        <i class="ri-loader-3-line spin fw-normal"></i> Abrir
                    </template>
                    <template v-else>
                        <i class="ri-play-fill fw-normal"></i> Abrir
                    </template>
                </button>
            </div>

            <!-- ✨ Caso em que é uma integração do zip zop meta ultra blaster master turbo supercharged shiny playtinum mvp plus plus harp 5 estrelas 12 estrelas ssr big mac -->
            <div v-else-if="isWppMetaAndInteractionWindowIsClosed" class="ciobaino-status-container" @click="abrirMenuMetaTemplates()">
                <div class="ciobaino-content">
                    <div class="ciobaino-icon-pulse">
                        <i class="ri-robot-3-line"></i>
                    </div>
                    <div class="ciobaino-text">
                        <strong>Janela de Atendimento Fechada</strong>
                        <span>A janela te atendimento está fechada. Clique aqui para enviar um template aprovado.</span>
                        <DropdownField
                            :shown="isTemplateListOpen"
                            placement="top-start"
                            :distance="50"
                            :skidding="50"
                            :triggers="[]"
                            :auto-hide="true"
                            @update:shown="(val: boolean) => isTemplateListOpen = val"
                        >
                            <div style="width: 0; height: 0; overflow: hidden;"></div>

                            <template #popper>
                                <TemplateSelection
                                    @close="isTemplateListOpen = false"
                                    @manage="isTemplateListOpen = false"
                                    @select-meta-template="insertMetaTemplate"
                                    @select-whiz-template="insertWhizTemplate"
                                />
                            </template>
                        </DropdownField>
                    </div>
                </div>
                <button class="btn btn-open" @click.stop="abrirMenuMetaTemplates()">
                    <i class="ri-puzzle-2-line fw-normal"></i> Enviar Template
                </button>
            </div>

            <template v-else>
            <!-- Aviso, não bloqueio: o campo continua ativo e o operador pode fechar. -->
            <div v-if="mostrarAvisoSemConta" class="sem-conta-aviso" role="status">
                <i class="ri-error-warning-line sem-conta-icone"></i>
                <div class="sem-conta-texto">
                    <strong>Número pode não ter WhatsApp</strong>
                    <span>Mensagens para este número podem não ser entregues.</span>
                </div>
                <button type="button" class="btn btn-sm sem-conta-fechar" title="Fechar aviso" @click="dispensarAvisoSemConta">
                    <i class="ri-close-line"></i>
                </button>
            </div>

            <div class="chat-input-wrapper" :class="{ 'input-filled': messageText.length > 0 }">

                <div class="col-auto">
                    <DropdownField
                        placement="top-start"
                        :distance="14"
                        :skidding="0"
                    >
                        <template #default>
                            <button
                                type="button"
                                class="btn icon-btn attach-btn"
                                :class="{ 'spin-animation': isAttachSpinning }"
                                title="Anexar"
                            >
                                <i class="ri-add-line"></i>
                            </button>
                        </template>

                        <template #popper="{ hide }">
                            <AttachMenu
                                @select="(type: string) => handleAttachSelect(type as 'file'|'contact'|'poll'|'template'|'note', hide)"
                                @file-selected="(files: File[]) => handleFileSend(files, hide)"
                                ref="attachMenuRef"
                            />
                        </template>
                    </DropdownField>
                </div>

                <DropdownField
                    :shown="isTemplateListOpen"
                    placement="top-start"
                    :distance="50"
                    :skidding="50"
                    :triggers="[]"
                    :auto-hide="true"
                    @update:shown="(val: boolean) => isTemplateListOpen = val"
                >
                    <div style="width: 0; height: 0; overflow: hidden;"></div>

                    <template #popper>
                        <TemplateSelection
                            @close="isTemplateListOpen = false"
                            @manage="isTemplateListOpen = false"
                            @select-meta-template="insertMetaTemplate"
                            @select-whiz-template="insertWhizTemplate"
                        />
                    </template>
                </DropdownField>

                <div class="col input-pill">
                    <template v-if="!isRecording">
                        <DropdownField
                            class="emoji-dropdown-wrapper"
                            placement="top-start"
                            :distance="14"
                            :skidding="0"
                        >
                            <template #default>
                                <button type="button" class="btn icon-btn emoji-btn" title="Emoji">
                                    <i class="ri-emoji-sticker-line"></i>
                                </button>
                            </template>

                            <template #popper>
                                <EmojiPickerField
                                    @select="onSelectEmoji"
                                    @sticker-select="onSelectSticker"
                                    :theme="isDarkMode ? 'dark' : 'light'"
                                />
                            </template>
                        </DropdownField>

                        <li>
                            <button
                                v-if="!chatStore.isTeamMode"
                                type="button"
                                class="btn icon-btn signature-btn"
                                :class="{ 'active': isSignatureEnabled || !hasDisablePermission }"
                                @click="hasDisablePermission ? chatStore.toggleSignature() : null"
                                v-tooltip="'Assinar mensagem'"
                            >
                                <i class="ri-sketching"></i>
                            </button>
                        </li>

                        <textarea
                            v-tooltip="linkedInboxIsOffline?'Inbox desconectada':''"
                            :disabled="linkedInboxIsOffline"
                            v-model="messageText"
                            ref="textarea"
                            class="form-control"
                            :class="{ 'no-signature': isTeamMode }"
                            placeholder="Digite uma mensagem"
                            rows="1"
                            @input="checkMentionTrigger"
                            @keydown="handleKeydown"
                            @paste="handlePaste"
                            @blur="handleBlur"
                        ></textarea>
                    </template>
                    <AudioRecorder v-else ref="audioRecorderRef" :formato="formatoDeAudio" @cancel="handleCancelRecording" @unsupported="handleUnsupportedRecording" />
                </div>

                <div class="col-auto">
                    <button v-if="messageText.trim().length > 0 || isRecording" @click="handleSend" type="submit" class="btn btn-primary font-size-16 btn-lg chat-send" :title="getSendButtonTitle">
                        <i :class="messageToEdit ? 'ri-check-line' : 'ri-send-plane-2-fill'"></i>
                    </button>
                    <button v-else @click="startRecording" type="button" class="btn btn-primary font-size-16 btn-lg chat-send" title="Gravar Áudio">
                        <i class="ri-mic-line"></i>
                    </button>
                </div>
            </div>
            </template>
        </template>

        <template v-else>
            <div class="chat-input-wrapper forward-bar">
                <div class="d-flex align-items-center gap-3">
                    <button type="button" class="btn icon-btn cancel-forward-btn" title="Cancelar"
                        @click="activeStore.cancelForwarding()">
                        <i class="ri-close-line"></i>
                    </button>
                    <div class="forward-count">
                        {{ forwardCount }} selecionada{{ forwardCount !== 1 ? 's' : '' }}
                    </div>
                </div>
                <div class="forward-actions d-flex align-items-center gap-2">
                    <button v-if="isManageMode && forwardCount > 0" @click="handleBulkDelete" type="button" class="btn icon-btn action-btn" title="Apagar">
                        <i class="ri-delete-bin-line"></i>
                    </button>
                    <button v-if="isManageMode && forwardCount > 0" @click="handleBulkStar" type="button" class="btn icon-btn action-btn" title="Favoritar">
                        <i class="ri-star-line"></i>
                    </button>
                    <button v-if="isManageMode && hasAudioSelected" @click="handleBulkDownload" type="button" class="btn icon-btn action-btn" title="Baixar">
                        <i class="ri-download-line"></i>
                    </button>
                    <button v-if="forwardCount > 0" @click="uiStore.openForwardModal()" type="button" class="btn icon-btn action-btn" title="Encaminhar">
                        <i class="ri-share-forward-line"></i>
                    </button>
                </div>
            </div>
        </template>

        <!-- Template com variáveis: a Meta recusa o envio (132000) se os valores não
             forem junto, então eles são coletados antes de a chamada sair. -->
        <MetaTemplateParamsModal
            v-model="isMetaTemplateParamsOpen"
            :template="templateAguardandoParams"
            :enviando="isSendingMetaTemplate"
            @confirmar="onMetaTemplateParamsConfirmados"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, nextTick, computed, watch } from 'vue';
import VideoDeChat from './VideoDeChat.vue';
import { dataURLtoFile, useChatStore } from '@/stores/app/chatStore';
import { formatoDeAudioDoCanal } from '@/services/inbox/inbox.service';
import { useInternalChatStore } from '@/stores/app/chatInternoStore';
import { useUiStore } from '@/stores/app/uiStore';
import AudioRecorder from './AudioRecorder.vue';
import Swal from 'sweetalert2';
import { toast } from 'vue3-toastify';

import EmojiPickerField from '@/components/forms/EmojiPickerField.vue';
import AttachMenu from './AttachMenu.vue';
import TemplateSelection from './TemplateSelection.vue';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { useMultiTemplateStore } from '@/stores/app/templateStore';
import { Chat, ChatMessageType, ChatParticipant, Message } from '@/mocks/app/mockChatData';
import { ResponseTemplate } from '@/services/templates/templates.service';
import { StorageService } from '@/stores/admin/storage';
import { IdAtendimento, IdContato, IdUsuario } from '@/services/common-types';
import { UsuariosContaAtual } from '@/utils/usuarios-conta-atual.composable';
import { GetReplyIconFromType, GetReplySnippet as getReplySnippet, MakeChat, MakeMessage } from '@/stores/app/chatUtils';
import { codigoEhLidDoContato, excedeTamanhoDeTelefone, standardizePhone } from '@/utils/phone';
import { downloadAudioFile } from '@/utils/audio/downloadAudioFile';
import { StrContainsNFDNormalized } from '@/utils/strContains';
import { usePermissoesStore } from '../../../../stores/app/permissoesStore';
import { useContatoStore } from '../../../../stores/app/contatoStore';
import { ContatoVariaveis, substituirVariaveisContato, variaveisDeNomeNaoResolvidas } from '@/services/agendamentos/substituir-variaveis-contato';
import { IntegracaoBotIaService } from '@/services/integracao-bot-ia/integracao-bot-ia.service';
import { AtendimentosService } from '@/services/atendimentos/atendimentos.service';
import { IMetaParams, IMetaTemplate, MetaTemplatesService } from '@/services/templates-wpp-meta/meta-wpp-template.service';
import { templateExigeParametros } from '@/services/templates-wpp-meta/meta-template-params';
import MetaTemplateParamsModal from '@/components/app/modals/MetaTemplateParamsModal.vue';
import { FetchMetaTemplates } from '@/utils/fetch-meta-templates.composable.js';

const storageService = new StorageService();
const authStore = useAuthStoreUser();

const isTemplateListOpen = ref(false);

const chatStore = useChatStore();
const internalChatStore = useInternalChatStore();
const isTeamMode = computed(() => chatStore.isTeamMode);
const isInternalChat = computed(
    () => internalChatStore.isInternalChatMode
);
// Formato de áudio pedido pelo canal: 'opus' no WhatsApp Cloud (é o que vira
// nota de voz), 'm4a' no Instagram/Messenger/IG Login, 'livre' no resto.
// Chat interno não passa por provider Meta, então nunca impõe formato.
const formatoDeAudio = computed(
    () => isInternalChat.value ? 'livre' : formatoDeAudioDoCanal(chatStore.activeChatType)
);
const uiStore = useUiStore();
const showMentionList = ref(false);
const mentionQuery = ref('');
const selectedMentionIndex = ref(0);
const cursorPositionAtMentionStart = ref<number | null>(null);
const mentioned = ref<ChatParticipant[]>([]);

const currentAccountUsers = UsuariosContaAtual();

const getSenderName = computed(() => (senderId?: IdContato|IdUsuario) => {
    if (!senderId) return 'Contato';

    const foundContato = chatStore.contatosById.get(senderId);
    const foundUsuario = currentAccountUsers.value.find(u => u.id == senderId);

    return foundContato?.nome || foundUsuario?.nome || 'Contato'
});

const permissoesStore = usePermissoesStore();
const contatoStore = useContatoStore();

const hasDisablePermission = computed(() => {
    const idConta = authStore.currentConta?.id;
    if (!idConta) return false;

    // 🔥 NOVO: Pega o ID da inbox do chat ativo
    const idInbox = chatStore.activeChat?.idInbox;
    if (!idInbox) return false;

    const permissao = 'inbox.desabilitar_assinatura_automatica';

    // ✅ Verifica a permissão SOMENTE na inbox do chat atual
    return permissoesStore.temPermissao(permissao, idConta, idInbox);

});

// #region Estados bloqueantes

const __debugForceShow_isWppMetaAndInteractionWindowIsClosed = ref(false);
const __debugForceHide_isWppMetaAndInteractionWindowIsClosed = ref(false);
const isWppMetaAndInteractionWindowIsClosed = computed(() => {
    if (__debugForceShow_isWppMetaAndInteractionWindowIsClosed.value) return true;
    if (__debugForceHide_isWppMetaAndInteractionWindowIsClosed.value) return false;
    if (chatStore.isGroupChat) return false;

    if (!chatStore.currentAccountHasOfficialWppIntegration) return false;
    if (!chatStore.inboxOfSelectedChatIsOfficialWpp)        return false;
    if (chatStore.currentChatHasOpenInteractionWindow)      return false;

    return true;
})

const __debugForceShow_isGroupAndInboxIsNonParticipating = ref(false);
const __debugForceHide_isGroupAndInboxIsNonParticipating = ref(false);
const isGroupAndInboxIsNonParticipating = computed(() => {
    if (__debugForceShow_isGroupAndInboxIsNonParticipating.value) return true;
    if (__debugForceHide_isGroupAndInboxIsNonParticipating.value) return false;
    if (chatStore.isGroupChat == false) return false;

    const currentChat = chatStore.activeChat;

    if (!currentChat) return false;
    const currentChatInbox = chatStore.inboxMap.get(currentChat.idInbox);

    if (!currentChatInbox) return false;
    const stdPhoneOptions = {returnErrorObject: false, returnToastError: false, throwError: false};
    const currChatInboxStdPhone = standardizePhone(currentChatInbox.dados.codigo, stdPhoneOptions)

    if (!currentChat?.participants) return false;
    if (currentChat.participants.length == 0) return false;

    // Em grupo announce (só administradores enviam) a ausência do inbox na lista NÃO
    // significa exclusão: o WhatsApp anonimiza os participantes não-administradores,
    // então o número simplesmente não aparece. Concluir "fora do grupo" aqui trocava
    // a causa real — falta de permissão — por uma acusação errada de remoção.
    if (currentChat.somenteAdmins) return false;

    return chatStore.isGroupChat && !currentChat.participants.find(p => standardizePhone(p.phone, stdPhoneOptions) == currChatInboxStdPhone)
});

/**
 * Grupo onde apenas administradores enviam e este inbox não é um deles.
 *
 * O papel vem da própria lista de participantes: administrador aparece com número
 * real (só o não-administrador é anonimizado), então não achar o inbox entre os
 * administradores é resposta suficiente.
 */
const isGroupAnnounceAndInboxIsNotAdmin = computed(() => {
    if (!chatStore.isGroupChat) return false;

    const currentChat = chatStore.activeChat;
    if (!currentChat?.somenteAdmins) return false;
    if (!currentChat.participants || currentChat.participants.length === 0) return false;

    const currentChatInbox = chatStore.inboxMap.get(currentChat.idInbox);
    if (!currentChatInbox) return false;

    const stdPhoneOptions = { returnErrorObject: false, returnToastError: false, throwError: false };
    const inboxPhone = standardizePhone(currentChatInbox.dados.codigo, stdPhoneOptions);

    return !currentChat.participants.some(
        p => p.isAdmin && standardizePhone(p.phone, stdPhoneOptions) === inboxPhone,
    );
});

const __debugForceShow_ChatControlledByAI = ref(false);
const __debugForceHide_ChatControlledByAI = ref(false);
const chatIsControlledByAI = computed(() => {
    if (__debugForceShow_ChatControlledByAI.value) return true;
    if (__debugForceHide_ChatControlledByAI.value) return false;
    if (internalChatStore.isInternalChatMode) return false;

    return !!chatStore.activeChat?.idChatBotIa && chatStore.activeChat?.statusIntegracaoIa != 'EM_ATENDIMENTO_HUMANO'
})

const __debugForceShow_ChatWasControlledByAI = ref(false);
const __debugForceHide_ChatWasControlledByAI = ref(false);
const chatWasAIControlledButIsHumanNow = computed(() => {
    if (__debugForceShow_ChatWasControlledByAI.value) return true;
    if (__debugForceHide_ChatWasControlledByAI.value) return false;
    if (internalChatStore.isInternalChatMode) return false;

    return !!chatStore.activeChat?.idChatBotIa && chatStore.activeChat?.statusIntegracaoIa == 'EM_ATENDIMENTO_HUMANO'
})

/**
 * Interromper o Agente de IA exige `inbox.interromper_fluxo_automatizado` NO
 * INBOX do chat aberto. Sem ela o banner continua visivel (o atendente precisa
 * saber que a IA esta conduzindo) porem apagado e inclicavel.
 */
const podeInterromperIa = computed(() =>
    chatStore.podeInterromperFluxoAutomatizado(chatStore.activeChat)
);

const interrompendoBotIa = ref(false);
async function interromperIa(chat: Chat) {
    if (interrompendoBotIa.value) return;
    // Guarda de verdade: o container inteiro e clicavel e o `:disabled` do botao
    // cobre so um dos dois caminhos ate aqui.
    if (!podeInterromperIa.value) return;
    try {
        interrompendoBotIa.value = true;
        await (new IntegracaoBotIaService()).interromperBotIa(chat.id as IdAtendimento, chat.idContaBotIa!, chat.idChatBotIa!);
        toast.success("IA interrompida e chat transferido para atendimento humano!")
    } catch (e) {
        toast.error((e as Error).message || `Não foi possível interromper o atendimento com IA.`);
    } finally {
        interrompendoBotIa.value = false;
    }
}

const chatIsControlledByBot = computed(() => {
    if (internalChatStore.isInternalChatMode) return false;
    return !!chatStore.activeChat?.isBotActive && !chatStore.activeChat?.isGroup;
})

const interrompendoBot = ref(false);
async function interromperBot(chat: Chat) {
    if (interrompendoBot.value) return;
    try {
        interrompendoBot.value = true;
        await new AtendimentosService().interromperBot(chat.id as IdAtendimento);
        await chatStore.abrirAtendimento(chat.id as IdAtendimento);
    } catch (e) {
        toast.error((e as Error).message || `Não foi possível interromper o bot.`);
    } finally {
        interrompendoBot.value = false;
    }
}

const __debugForceShow_ChatIsOpenButAtendimentoIsNotOpen = ref(false);
const __debugForceHide_ChatIsOpenButAtendimentoIsNotOpen = ref(false);
const chatIsOpenButAtendimentoIsNotOpen = computed(() => {
    if (__debugForceShow_ChatIsOpenButAtendimentoIsNotOpen.value) return true;
    if (__debugForceHide_ChatIsOpenButAtendimentoIsNotOpen.value) return false;
    if (internalChatStore.isInternalChatMode)                return false;

    return !chatStore.activeChat?.isGroup && chatStore.activeChat?.status == 'Criado'
});
const abrindoAtendimento = ref(false);
async function abrirAtendimento(chat: Chat) {
    if (abrindoAtendimento.value) return;
    try {
        abrindoAtendimento.value = true;
        return await chatStore.abrirAtendimento(chat.id as IdAtendimento);
    } catch (e) {
        toast.error((e as Error).message || `Não foi possível abrir o atendimento.`);
    } finally {
        abrindoAtendimento.value = false;
    }
}

// #endregion

const onSelectSticker = async (sticker: string) => {
    const isRemoteUrl = /^https?:/i.test(sticker);
    const isInternalChat = uiStore.activeTab == 'ChatEquipe';

    try {
        // Figurinha já hospedada no nosso storage: envia só a URL. Nada é baixado
        // pelo navegador — buscar essa URL com fetch() é bloqueado pelo Chrome.
        if (isRemoteUrl) {
            if (isInternalChat) {
                await internalChatStore.sendStickerMessageByUrl(sticker);
                void chatStore.trackStickerUsage(sticker);
                return;
            }
            return await chatStore.sendStickerMessage(sticker);
        }

        // data:/blob: — conversão local, sem tráfego de rede.
        const file = sticker.startsWith('data:')
            ? dataURLtoFile(sticker, 'sticker.webp')
            : new File([await (await fetch(sticker)).blob()], 'sticker.webp', { type: 'image/webp' });

        if (!file) throw new Error('Não foi possível converter a imagem da figurinha.');

        if (isInternalChat) await internalChatStore.sendStickerMessage(file);
        else await chatStore.sendStickerMessage(file);
    } catch (e) {
        console.error("Erro ao processar figurinha", e);
        toast.error("Falha ao enviar figurinha.");
    }
};

// Computada para filtrar participantes
const filteredParticipants = computed(() => {
    // Verifica se é grupo e se tem participantes
    if (!chatStore.activeChat?.isGroup || !chatStore.activeChat?.participants) return [];

    const query = mentionQuery.value;

    return chatStore.activeChat.participants.filter(p => {
        if (!MakeChat.participantePodeSerMencionado(p)) return false;

        const matchName = StrContainsNFDNormalized(query, p.name);
        const matchPhone = p.phone ? StrContainsNFDNormalized(query, p.phone, { stripNonAlphanumeric: true }) : false;
        return matchName || matchPhone;
    });
});

// Helper para iniciais
const getInitials = (name: string) => {
    return name.substring(0, 2).toUpperCase();
};

const handleBlur = () => {
    // Pequeno delay para permitir que o clique no item da lista seja processado
    setTimeout(() => {
        showMentionList.value = false;
    }, 200);
};

// Função para detectar o @ durante a digitação
const checkMentionTrigger = (event: Event) => {
    handleInput(); // Chama a função original de autoGrow

    if (!chatStore.activeChat?.isGroup) return;

    const el = event.target as HTMLTextAreaElement;
    const cursor = el.selectionStart;
    const text = el.value;

    // Pega o texto até o cursor
    const textBeforeCursor = text.slice(0, cursor);

    // Regex para pegar a última palavra se ela começar com @
    // Ex: "Olá @Mar" -> match: "@Mar"
    const match = textBeforeCursor.match(/(?:\s|^)@((?:\w|[áàâãäçéèêëíìîïóòôõöúùûüñýÁÀÂÃÄÇÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÑÝ])*)$/);

    if (match) {
        showMentionList.value = true;
        mentionQuery.value = match[1]; // O que vem depois do @

        // Salva onde o @ começou para substituir depois
        // match.index é relativo ao início, precisamos ajustar se tiver espaço antes
        const matchIndex = match.index !== undefined ? match.index : 0;
        cursorPositionAtMentionStart.value = textBeforeCursor.endsWith(match[0])
            ? matchIndex + (match[0].startsWith(' ') ? 1 : 0) // Ajusta se pegou o espaço
            : cursor - match[0].length;

        selectedMentionIndex.value = 0; // Reset seleção
    } else {
        showMentionList.value = false;
        cursorPositionAtMentionStart.value = null;
    }
};

// Função ao selecionar um participante
const selectParticipant = (participant: ChatParticipant) => {
    if (cursorPositionAtMentionStart.value === null || !textarea.value) return;

    const originalText = messageText.value;
    const beforeMention = originalText.slice(0, cursorPositionAtMentionStart.value);

    // O que vem depois do cursor atual (para não perder o resto do texto)
    const currentCursor = textarea.value.selectionStart;
    const afterCursor = originalText.slice(currentCursor);

    // Inserir a menção formatada "@Nome "
    const mentionText = `@${participant.name} `;

    messageText.value = beforeMention + mentionText + afterCursor;

    showMentionList.value = false;

    // Focar e ajustar cursor
    nextTick(() => {
        if (textarea.value) {
            textarea.value.focus();
            const newCursorPos = beforeMention.length + mentionText.length;
            textarea.value.selectionStart = newCursorPos;
            textarea.value.selectionEnd = newCursorPos;
        }
    });

    const foundMention = mentioned.value.find(p => p.phone == participant.phone);
    if (!foundMention) mentioned.value.push(participant);
};

// Navegação por teclado no dropdown (Opcional, adicionar no @keydown do textarea)
const handleKeydown = (e: KeyboardEvent) => {
    // Negrito (Ctrl+B → *), itálico (Ctrl+I → _) e tachado (Ctrl+Shift+X → ~)
    const key = e.key.toLowerCase();
    const isBoldOrItalic = (e.ctrlKey || e.metaKey) && !e.shiftKey && (key === 'b' || key === 'i');
    const isStrikethrough = (e.ctrlKey || e.metaKey) && e.shiftKey && key === 'x';
    if (isBoldOrItalic || isStrikethrough) {
        e.preventDefault();
        const el = textarea.value;
        if (!el) return;
        const start = el.selectionStart;
        const end = el.selectionEnd;
        if (start === end) return;
        const marker = isStrikethrough ? '~' : (key === 'b' ? '*' : '_');
        const selected = messageText.value.slice(start, end);
        messageText.value = messageText.value.slice(0, start) + marker + selected + marker + messageText.value.slice(end);
        nextTick(() => {
            el.selectionStart = start + marker.length;
            el.selectionEnd = end + marker.length;
            el.focus();
        });
        return;
    }
    if (showMentionList.value && filteredParticipants.value.length > 0) {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            selectedMentionIndex.value = (selectedMentionIndex.value + 1) % filteredParticipants.value.length;
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            selectedMentionIndex.value = (selectedMentionIndex.value - 1 + filteredParticipants.value.length) % filteredParticipants.value.length;
        } else if (e.key === 'Enter' || e.key === 'Tab') {
            e.preventDefault();
            selectParticipant(filteredParticipants.value[selectedMentionIndex.value]);
        } else if (e.key === 'Escape') {
            showMentionList.value = false;
        }
    } else if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSend();
    }
};

const linkedInboxIsOffline = computed(() => {
    if (internalChatStore.isInternalChatMode) return false;
    if (chatStore.inboxOfSelectedChatIsOfficialWpp) return false;

    const currentInbox = chatStore.connectedInboxesStatus.find(
        i => i.id == chatStore.activeChat?.idInbox
    );

    return !currentInbox?.isConnected;
});

const contactNumbeExistsOnWhatsApp = ref<boolean | undefined>(undefined);

const messageText = ref('');
const textarea = ref<HTMLTextAreaElement|null>(null);
const isRecording = ref(false);
const audioRecorderRef = ref<InstanceType<typeof AudioRecorder> | null>(null);
const attachMenuRef = ref<InstanceType<typeof AttachMenu>|null>(null);

const activeStore = computed(() =>
    internalChatStore.isInternalChatMode
        ? internalChatStore
        : chatStore
);


const messageToReply = computed(() => activeStore.value.messageToReply);
const messageToEdit = computed(() => activeStore.value.messageToEdit);
const respostaParticular = computed(() => internalChatStore.isInternalChatMode ? null : chatStore.respostaParticularAtiva);

const isForwarding = computed(() => activeStore.value.isForwarding);
const forwardCount = computed(() => activeStore.value.forwardingMessageIds.length);
const isManageMode = computed(() => activeStore.value.selectionContext === 'manage');
const isDarkMode = computed(() => uiStore.theme === 'dark');

const isAttachSpinning = ref(false);
const isSignatureEnabled = computed(() => chatStore.isSignatureEnabled);

const selectedMessages = computed(() => {
    return activeStore.value.messages.filter(msg =>
        activeStore.value.forwardingMessageIds.includes(msg.id)
    );
});
const hasAudioSelected = computed(() => {
    return selectedMessages.value.some(msg => msg.type === 'audio');
});

const { officialTemplatesDoChatAtivo } = FetchMetaTemplates(chatStore);

/**
 * Existe algo para o menu rápido mostrar neste chat?
 *
 * Antes o gate era `isOfficialInbox`, que num híbrido saudável é `false` — o "/"
 * então só olhava os templates Whiz e não abria nada quando a conta só tinha
 * templates oficiais. Agora segue o mesmo modo que o TemplateSelection usa.
 */
const temTemplatesParaMenuRapido = computed(() => {
    const metaAprovados = officialTemplatesDoChatAtivo.value.filter(t => t.status == 'APPROVED').length;
    switch (chatStore.modoTemplatesRapidos) {
        case 'SO_META': return metaAprovados > 0;
        case 'META_E_WHIZ': return metaAprovados > 0 || currentContaTemplates.value.length > 0;
        default: return currentContaTemplates.value.length > 0;
    }
});

const currentContaId = computed(() => authStore.currentConta?.id)
const templateStore = useMultiTemplateStore();
watch(() => authStore.initialized, (isInit) => isInit
    ? templateStore.init(authStore.contasFull.map(c => c.id))
    : null
);
const currentContaTemplates = computed(() => currentContaId.value ? templateStore.contasTemplatesMap.get(currentContaId.value) ?? [] : []);


// manter o '=== false': undefined = não foi possível saber, e aí não se avisa.
// Aviso, não bloqueio: o `false` em cache pode ser uma resposta ambígua do
// WhatsApp (throttle, erro), então o texto não afirma e o operador pode fechar.
const mostrarAvisoSemConta = computed(() => {
    const idContato = chatStore.activeChat?.idContato;
    if (!idContato || isInternalChat.value || chatStore.activeChat?.isGroup) return false;
    if (chatStore.semContaDispensados[idContato]) return false;
    return contactNumbeExistsOnWhatsApp.value === false;
});

const dispensarAvisoSemConta = () => {
    const idContato = chatStore.activeChat?.idContato;
    if (idContato) chatStore.semContaDispensados[idContato] = true;
};

// Código de WhatsApp: contato do tipo WHATSAPP OU inbox de WhatsApp (o contato
// pode não estar no cache). Instagram/Messenger guardam IGSID/PSID (16–17 dígitos)
// no mesmo campo, e canal desconhecido também fica fora.
const chatEhWhatsapp = () => {
    const chat = chatStore.activeChat;
    if (!chat) return false;
    const tipo = chat.idContato ? chatStore.contatosById.get(chat.idContato)?.tipo : undefined;
    if (tipo === 'WHATSAPP') return true;
    const plataforma = chat.idInbox ? chatStore.inboxMap.get(chat.idInbox)?.plataforma : undefined;
    return !!plataforma?.startsWith('WHATSAPP_');
};

const checkContactNumber = async () => {
  const idContato = chatStore?.activeChat?.idContato;

  if (!idContato) return;

  // Não é telefone (>15 dígitos): sem WhatsApp, e consultar só devolveria "desconhecido".
  const codigo = chatStore?.activeChat?.codigoContato;
  // `lid` está na resposta do servidor, mas não no tipo do front.
  const lid = (chatStore.contatosById.get(idContato as IdContato) as { lid?: string | null } | undefined)?.lid;
  if (chatEhWhatsapp() && !codigoEhLidDoContato(codigo, lid) && excedeTamanhoDeTelefone(codigo)) {
    contactNumbeExistsOnWhatsApp.value = false;
    return;
  }

  const existe = await contatoStore.verificarExistenciaWpp(idContato);

  // Troca rápida de conversa: a resposta de A não pode pintar o aviso em B.
  if (chatStore?.activeChat?.idContato !== idContato) return;

  contactNumbeExistsOnWhatsApp.value = existe;
};

watch(() => activeStore.value.activeChatId, (newId) => {
    if (newId) {
        const store = activeStore.value;

        contactNumbeExistsOnWhatsApp.value = undefined;

        if (!isInternalChat.value && !chatStore.activeChat?.isGroup) {
           void checkContactNumber();
        }

        const savedDraft = store.draftsDict[newId] || '';
        messageText.value = savedDraft;

        if (savedDraft) {
            nextTick(() => {
                autoGrow();
                if (textarea.value) textarea.value.focus();
            });
        }
    } else {
        messageText.value = '';
    }
}, { immediate: true });

watch(messageText, (newVal) => {
    if (internalChatStore.isInternalChatMode) {
        if (internalChatStore.activeChatId) {
            internalChatStore.setDraft(internalChatStore.activeChatId, newVal);
        }
        // Campo esvaziado (apagou tudo, ou acabou de enviar) ⇒ parou de digitar.
        // Sem isto o indicador do outro lado só sumiria pelo TTL de 8 s.
        if (newVal.length === 0) internalChatStore.anunciarParadaDigitacaoChatInterno();
        else internalChatStore.anunciarDigitacaoChatInterno();
    } else {
        if (chatStore.activeChatId) {
            chatStore.setDraft(chatStore.activeChatId, newVal);
        }
    }
});

watch(messageText, (newVal, oldVal) => {
    if (oldVal.length === 0 && newVal.length > 0) {
        isAttachSpinning.value = true;
        setTimeout(() => {
            isAttachSpinning.value = false;
        }, 500);
    }

    if (newVal === '/' && !isTeamMode.value) {
        if (temTemplatesParaMenuRapido.value) {
            isTemplateListOpen.value = true;
        }
    } else if (newVal === '') {
        isTemplateListOpen.value = false;
    }
});

const handleInput = () => {
    autoGrow();
};

const closeEditPreview = () => {
    if (chatStore.chatContext === 'team') {
        internalChatStore.clearEditMessage();
    } else {
        chatStore.clearEditMessage();
    }
};

const closeReplyPreview = () => {
    if (chatStore.chatContext === 'team') {
        internalChatStore.clearReply();
    } else {
        chatStore.clearReplyMessage();
    }
};

const cancelarRespostaParticular = () => {
    if (chatStore.activeChatId) chatStore.limparRespostaParticular(chatStore.activeChatId);
};

const handleSend = () => {
    if (isRecording.value) {
        sendAudio();
    } else {
        handleSendMessage();
    }
}

//edição de chat interno
const handleSendMessage = async () => {
    let text = messageText.value.trim();
    if (!text) return;

    mentioned.value = mentioned.value
      .filter((participant: ChatParticipant) => text.includes(`@${participant.name}`))
      .map((participant: ChatParticipant) => ({ ...participant, phone: participant.phone.replace(/^(55\d{2})9(\d{8})$/, "$1$2") }));

    mentioned.value.forEach((participant: ChatParticipant) => {
      text = text.replaceAll(`@${participant.name}`, `@${participant.phone}`);
    });

    // 👉 EDIÇÃO
    if (messageToEdit.value) {
        if (isInternalChat.value) {
            await internalChatStore.editarMensagem(
                messageToEdit.value.id,
                text
            );
        } else {
            await chatStore.sendMessage(text);
        }

        messageText.value = '';
        closeEditPreview();
        return;
    }

    // Chat Interno
    if (isInternalChat.value) {
        internalChatStore.sendMessage(
            text,
            messageToReply.value?.id
        );
        if (internalChatStore.activeChatId) {
            internalChatStore.setDraft(internalChatStore.activeChatId, null);
        }
    } else { // Atendimento
        chatStore.sendMessage(text, mentioned.value);


        if (chatStore.activeChatId) {
            chatStore.setDraft(chatStore.activeChatId, null);
        }
        messageText.value = '';

        nextTick(() => {
            if (textarea.value) {
                textarea.value.style.height = 'auto';
                textarea.value.style.overflowY = 'hidden';
                textarea.value.focus();
            }
        });

    }

    messageText.value = '';
    mentioned.value = [];

    nextTick(() => {
        if (textarea.value) {
            textarea.value.style.height = 'auto';
            textarea.value.style.overflowY = 'hidden';
            textarea.value.focus();
        }
    });
};

const handleAttachSelect = (type: 'file'|'contact'|'poll'|'template'|'note', hidePopper?: () => any) => {
    if (typeof hidePopper === 'function') {
        hidePopper();
    }
    setTimeout(() => {
        switch (type) {
            case 'file':
                if (attachMenuRef.value) {
                    attachMenuRef.value.triggerFileSelect();
                }
                break;
            case 'contact':
                uiStore.openSendContactModal();
                break;
            case 'poll':
                toast.info('Em breve');
                break;
            case 'template':
                handleTemplateAction();
                break;
            case 'note':
                // Anotação interna: nunca passa pelo fluxo de envio de mensagem.
                chatStore.abrirModalAnotacaoInterna();
                break;
        }
    }, 100);
};

const handlePaste = (event: ClipboardEvent) => {
    // @ts-expect-error hmm.
    const items = (event.clipboardData || window.clipboardData).items;

    for (const item of items) {
        if (item.kind === 'file' && item.type.startsWith('image/')) {
            event.preventDefault();

            const file = item.getAsFile();

            if (file) {
                uiStore.openFilePreviewModal(file);
            }

            return;
        }
    }
};

const funcaoQrcode = () => {
    const idInbox = chatStore.activeChat?.idInbox;

    if (idInbox) {
        chatStore.showQrCode(idInbox);
    } else {
        toast.error("Não foi possível identificar a instância deste chat.");
    }
};

const handleTemplateAction = () => {
    if (temTemplatesParaMenuRapido.value) isTemplateListOpen.value = true;
    else uiStore.openTemplatesModal();
};

const isSendingMetaTemplate = ref(false);
/** Template escolhido que ainda espera os valores das variáveis. */
const templateAguardandoParams = ref<IMetaTemplate | null>(null);
const isMetaTemplateParamsOpen = ref(false);

/**
 * Envio rápido de template pelo chat.
 *
 * Template com variáveis precisa passar pelo formulário antes: até então este caminho
 * mandava `{replace:null}` para qualquer template, e a Meta recusava com 132000
 * ("number of localizable_params (0) does not match the expected number of params"),
 * que chegava ao operador como erro interno.
 */
async function insertMetaTemplate(metaWppTemplate: IMetaTemplate) {
    isTemplateListOpen.value = false;
    if (isSendingMetaTemplate.value) return;

    if (templateExigeParametros(metaWppTemplate)) {
        templateAguardandoParams.value = metaWppTemplate;
        isMetaTemplateParamsOpen.value = true;
        return;
    }

    await enviarMetaTemplate(metaWppTemplate);
}

async function enviarMetaTemplate(metaWppTemplate: IMetaTemplate, params?: IMetaParams) {
    // Envio de template era o único caminho do chat sem retorno imediato: o operador
    // clicava, a lista fechava e nada mudava na tela até o webhook da Meta voltar. O
    // toast e a bolha provisória existem para o clique ter resposta na hora.
    // A trava vem ANTES do toast e da bolha: um segundo clique não pode deixar um toast
    // de carregamento e uma bolha provisória órfãos na tela.
    if (isSendingMetaTemplate.value) return;
    isSendingMetaTemplate.value = true;

    const idToast = toast.loading('Enviando template...');
    const idOtimista = chatStore.adicionarTemplateMetaOtimista(metaWppTemplate, params ?? { replace: null });

    try {
        const idContato = chatStore.activeChat?.idContato;
        if (!idContato) {
            throw new Error(`Não é possível enviar templates Meta para grupos.`);
        }

        await new MetaTemplatesService().send(metaWppTemplate.id, idContato, params);

        isMetaTemplateParamsOpen.value = false;
        templateAguardandoParams.value = null;
        // A bolha provisória continua na tela: quem a substitui é o evento real da
        // mensagem, que traz o id do servidor, a situação e — se a Meta recusar depois —
        // o motivo.
        toast.update(idToast, { render: 'Template enviado!', type: 'success', isLoading: false, autoClose: 3000 });
    } catch (e) {
        // Envio que nem saiu não deixa bolha provisória para trás. Quando a recusa vem da
        // Meta, o servidor grava a tentativa com o motivo e ela chega pelo websocket como
        // bolha de falha — esta remoção não a apaga, porque aquela tem id do servidor.
        chatStore.removerMensagemOtimista(idOtimista);

        // O servidor devolve a recusa da Meta já traduzida (falta de pagamento, janela
        // fechada, limite). O texto é longo de propósito porque diz o que fazer, então
        // o toast fica mais tempo na tela do que o padrão.
        const motivo = (e as { message?: string })?.message || `Não foi possível enviar o template.`;
        toast.update(idToast, { render: motivo, type: 'error', isLoading: false, autoClose: 10000 });
    } finally {
        isSendingMetaTemplate.value = false;
    }
}

const onMetaTemplateParamsConfirmados = async (params: IMetaParams) => {
    const template = templateAguardandoParams.value;
    if (!template) return;
    await enviarMetaTemplate(template, params);
};

// Outro componente (ex.: Ações AXION) pediu para inserir texto no input. Acrescenta
// ao que já estiver digitado, foca no fim e limpa o pedido na store.
watch(() => chatStore.textoParaInserirNoInput, (texto) => {
    if (!texto) return;

    messageText.value = messageText.value ? `${messageText.value} ${texto}` : texto;
    chatStore.limparTextoParaInserirNoInput();

    nextTick(() => {
        if (textarea.value) {
            autoGrow();
            textarea.value.focus();
            textarea.value.selectionStart = textarea.value.selectionEnd = textarea.value.value.length;
        }
    });
});

/**
 * Contato do chat aberto, para resolver `{nome_contato}`/`{nome_whatsapp}` de um
 * template Whiz.
 *
 * `null` em grupo e no chat interno: lá `activeChat.name` é o nome do grupo/colega,
 * e substituir a variável de contato por ele seria mandar o nome errado ao cliente.
 */
const contatoDoChatParaVariaveis = computed<ContatoVariaveis | null>(() => {
    if (internalChatStore.isInternalChatMode) return null;
    const chat = chatStore.activeChat;
    if (!chat || chat.isGroup || !chat.idContato) return null;
    return { nome: chat.name, nomeWhatsapp: chat.nomeWhatsappContato };
});

/**
 * Resolve as variáveis de nome do template e avisa o que ficou de fora.
 *
 * Aqui a substituição é DEFINITIVA — o texto vai para o input e sai como está —,
 * então o que não resolve continua literal (`{nome_contato}` visível) em vez de
 * virar buraco na frase, com um toast dizendo qual variável o operador precisa
 * completar na mão.
 */
const resolverVariaveisDoTemplate = (texto: string): string => {
    const contato = contatoDoChatParaVariaveis.value;
    const naoResolvidas = variaveisDeNomeNaoResolvidas(contato, texto);

    if (naoResolvidas.length) {
        toast.warning(`Este chat não tem contato para preencher ${naoResolvidas.join(' e ')}. Complete no texto antes de enviar.`);
    }

    return substituirVariaveisContato(contato, texto);
};

const insertWhizTemplate = async (template: ResponseTemplate) => {
    isTemplateListOpen.value = false;

    if (messageText.value === '/') {
        messageText.value = '';
    } else if (messageText.value.endsWith('/')) {
        // Se tinha texto antes (ex: "ola /"), remove só a barra final
        messageText.value = messageText.value.slice(0, -1);
    }

    // 1. TEXTO: Inserir no input e focar
    if (template.conteudo === 'TEXTO') {
        // CORREÇÃO: Garante que pega 'message' ou 'mensagem' (conforme sua interface) e fallback para string vazia
        const textToInsert = resolverVariaveisDoTemplate(template.mensagem || '');

        if (!textToInsert) return; // Se não tiver texto, não faz nada

        if (messageText.value) {
            messageText.value += ` ${textToInsert}`;
        } else {
            messageText.value = textToInsert;
        }

        nextTick(() => {
            if (textarea.value) {
                autoGrow();
                textarea.value.focus();
                // Move cursor para o final
                textarea.value.selectionStart = textarea.value.selectionEnd = textarea.value.value.length;
            }
        });
        return;
    }
    // 2. ANEXO: Converter URL em File (Mock) ou abrir Preview
    if (template.conteudo === 'ANEXO') {
        if (template.mensagem) {
            try {
                // Tenta baixar o arquivo para criar um objeto File
                // (Como é mock, vamos simular um File se a URL for inválida ou externa)
                let file;

                // Em produção real com backend:
                const response = await fetch(template.mensagem);
                const blob = await response.blob();
                // Nome real do arquivo a partir da URL (sem querystring), não fixo ".pdf"
                const rawName = decodeURIComponent(template.mensagem.split('?')[0].split('/').pop() || '');
                const filename = rawName || 'arquivo_template';
                file = new File([blob], filename, { type: blob.type });

                // // Mock Simples: Cria um arquivo vazio com o nome correto para o Preview abrir
                // file = new File(["mock content"], "Catalogo.pdf", { type: "application/pdf" });

                // Abre o FilePreviewModal
                uiStore.openFilePreviewModal(file);

                // Opcional: Se quiser já preencher a legenda
                // `template.mensagem` aqui é a URL do arquivo, não texto — só a legenda
                // passa pelas variáveis.
                if (template.legenda) {
                    uiStore.previewItems[0].caption = resolverVariaveisDoTemplate(template.legenda);
                }

            } catch (e) {
                toast.error("Erro ao carregar anexo do template.");
            }
        }
        return;
    }

    // 3. PIX ou SENHA: Modal de Confirmação
    if (template.conteudo === 'PIX' || template.conteudo === 'SENHA_USO_UNICO') {
        uiStore.openConfirmTemplateModal(template);
    }
};

const handleFileSend = (files: File|File[], hidePopper?: () => any) => {
    if (!Array.isArray(files)) files = [files];
    if (typeof hidePopper === 'function') hidePopper();
    uiStore.openFilePreviewModal(files);
};

const onSelectEmoji = (emoji: { i: string }) => {
    if (!textarea.value) {
        messageText.value += emoji.i;
        return;
    }

    const input = textarea.value;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const text = messageText.value;
    const before = text.substring(0, start);
    const after = text.substring(end);

    messageText.value = before + emoji.i + after;

    nextTick(() => {
        autoGrow();
        if (textarea.value) {
            textarea.value.selectionStart = textarea.value.selectionEnd = start + emoji.i.length;
            textarea.value.focus();
        }
    });
};

const handleBulkDelete = () => {
    Swal.fire({
        title: `Apagar ${forwardCount.value} mensagens?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef476f',
        cancelButtonColor: '#343a40',
        confirmButtonText: 'Sim, apagar',
        cancelButtonText: 'Cancelar'
    }).then(async (result) => {
        if (result.isConfirmed) {
            const messageDict: Map<string, Message> = new Map(activeStore.value.messages.map(m => [m.id, m]));
            const ids = [...activeStore.value.forwardingMessageIds];
            // Um ID sem mensagem correspondente viraria `undefined` dentro do deleteMessage.
            const messagesToDelete = ids.map(id => messageDict.get(id)).filter((m): m is Message => !!m);

            const idsNaoEncontrados = ids.length - messagesToDelete.length;
            if (idsNaoEncontrados > 0) {
                console.error('[handleBulkDelete] IDs selecionados sem mensagem correspondente', {
                    ids, encontrados: messagesToDelete.map(m => m.id)
                });
            }

            const resultados = await Promise.all(messagesToDelete.map(m => activeStore.value.deleteMessage(m)));
            const apagadas = resultados.filter(Boolean).length;

            activeStore.value.cancelForwarding();

            // Antes o sucesso era anunciado incondicionalmente: quando nada era apagado
            // (ID não resolvido, store sem suporte a exclusão, falha no envio) o usuário
            // via "Mensagens apagadas." e a conversa intacta.
            if (apagadas === 0) {
                toast.error("Nenhuma mensagem foi apagada.");
            } else if (apagadas < ids.length) {
                toast.warning(`${apagadas} de ${ids.length} mensagens apagadas.`);
            } else {
                toast.success(apagadas === 1 ? "Mensagem apagada." : "Mensagens apagadas.");
            }
        }
    });
};

const handleBulkStar = () => {
    const idsToStar = [...activeStore.value.forwardingMessageIds];
    idsToStar.forEach(id => activeStore.value.toggleFavoriteMessage(id));
    toast.success("Favoritos atualizados.");
};

const handleBulkDownload = () => {
    const audioMessages = selectedMessages.value.filter(m => m.type === 'audio' && m.audioUrl);
    if (audioMessages.length === 0) return;
    audioMessages.forEach((msg, index) => {
        setTimeout(() => {
            downloadAudioFile(msg.audioUrl!, `audio_${msg.id}`)
                .catch(error => console.error('Erro ao tentar baixar o áudio:', error));
        }, index * 200);
    });
};

watch(messageToEdit, (newMessage) => {
    if (newMessage) {
        const editableText = newMessage.text ?? newMessage.fileData?.caption ?? '';
        messageText.value = editableText;
        focusAndGrow();
    } else {
        if (!messageToReply.value) { messageText.value = ''; }
    }
});

watch(messageToReply, (newReply) => {
    if (!newReply && !messageToEdit.value) { messageText.value = ''; }
});

// Chegou da ação "Responder em particular": o campo já fica pronto para digitar.
watch(() => respostaParticular.value?.mensagem.id, (idMensagem) => {
    if (idMensagem) focusAndGrow();
});

const getSendButtonTitle = computed(() => {
    if (isRecording.value) return 'Enviar Áudio';
    if (messageToEdit.value) return 'Salvar Edição';
    return 'Enviar Mensagem';
});

const focusAndGrow = () => {
    nextTick(() => {
        if (textarea.value) {
            textarea.value.focus();
            autoGrow();
        }
    });
};

const autoGrow = () => {
    const el = textarea.value;
    if (!el) return;
    const maxHeight = 150;
    el.style.height = 'auto';
    if (el.scrollHeight > maxHeight) {
        el.style.height = maxHeight + 'px';
        el.style.overflowY = 'auto';
    } else {
        el.style.height = (el.scrollHeight) + 'px'; el.style.overflowY = 'hidden';
    }
}

const startRecording = () => { isRecording.value = true; };

const handleCancelRecording = ()=> {
    if (audioRecorderRef.value) {
        audioRecorderRef.value.cancelStream();
    }
    isRecording.value = false;
};

// Falhas que abortam a gravação antes de começar. O gravador manda o motivo já
// escrito para o usuário (microfone ausente/negado/ocupado, ou nenhum caminho
// capaz de produzir audio/mp4 AAC). Sem isso, um `NotFoundError: Requested
// device not found` sumia no console e a barra de gravação só fechava sozinha.
const handleUnsupportedRecording = (motivo?: string) => {
    isRecording.value = false;
    toast.error(
        motivo ||
        'Seu navegador não suporta gravar áudio no formato exigido por este canal (audio/mp4, AAC). Use Chrome/Edge no Windows/macOS/Android, ou Safari.',
    );
};

const sendAudio = async () => {
   if (!audioRecorderRef.value) return;

    try {
        const { blob, duration, waveform } =
            await audioRecorderRef.value.stopAndGetBlob() as {
                blob: Blob;
                duration: string;
                waveform: number[];
            };

        // 👉 CHAT INTERNO
        if (isInternalChat.value) {
            const audioFile = new File(
                [blob],
                `audio-${Date.now()}.webm`,
                { type: blob.type || 'audio/webm' }
            );

            const storage = await storageService.uploadChatInternoFile({
                file: audioFile
            }, true);

            await internalChatStore.sendAudioMessage(storage.path);
            return;
        }

        // 👉 CHAT NORMAL
        chatStore.sendAudioMessage(
            blob,
            duration,
            waveform
        );

    } catch (error) {
        console.error("Erro ao enviar áudio:", error);
    } finally {
        isRecording.value = false;
    }
};

async function abrirMenuMetaTemplates() {
    isTemplateListOpen.value = true;
    console.log('[abrirMenuMetaTemplates] ✨')
}
</script>

<style scoped>
.chat-input-section {
    background-color: transparent;
    border-top: none !important;
    flex-shrink: 0;
    padding: 10px 12px;
    position: relative;
    z-index: 2;
}
.chat-input-wrapper { display: flex; align-items: flex-end; gap: 8px; }
@media (max-width: 991.98px) {
    .chat-input-wrapper { 
        gap: 6px; 
        padding: 4px;
    }

    .input-pill {
        flex: 1 1 auto;
        min-width: 0; 
        padding: 0 4px;
    }

    .chat-send {
        width: 44px; 
        height: 44px; 
        font-size: 18px;
    }

    .icon-btn {
        width: 36px;
        height: 36px;
        font-size: 20px;
    }
}
.input-pill {
    display: flex; align-items: center; position: relative;
    background-color: var(--bs-light); border-radius: 28px; padding: 0 8px;
    transition: all 0.2s ease; flex-grow: 1;
}
[data-bs-theme="light"] .input-pill{ background-color: var(--bs-white); }

textarea.form-control {
    min-height: 48px !important; max-height: 150px; resize: none; overflow-y: hidden;
    background-color: transparent !important; border-color: transparent !important;
    box-shadow: none !important; color: var(--bs-dark);
    padding: 13px 8px 13px 44px !important; font-size: 15px; line-height: 1.5;
}
textarea.form-control::placeholder { color: var(--bs-text-muted); }
textarea.form-control:focus { box-shadow: none !important; }

/* Botões */
.icon-btn {
    color: var(--bs-text-muted); border-radius: 50%; width: 40px; height: 40px;
    font-size: 24px; display: flex; align-items: center; justify-content: center;
    transition: background-color 0.2s ease, color 0.2s ease; flex-shrink: 0;
    border: none;
}
.icon-btn:hover { background-color: var(--bs-border-color); color: var(--bs-dark); }

.attach-btn { width: 48px; height: 48px; font-size: 26px; }
.attach-btn:hover { background-color: var(--bs-light); }
[data-bs-theme="light"] .attach-btn:hover { background-color: var(--bs-white); }


@keyframes spin-once {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.spin-animation {
    animation: spin-once 0.5s ease-in-out;
}

.emoji-btn { position: relative; }
.emoji-dropdown-wrapper { position: absolute !important; left: 4px; bottom: 4px; z-index: 3; }

.chat-send {
    width: 48px; height: 48px; border-radius: 50% !important;
    background-color: var(--bs-success); border-color: var(--bs-success); font-size: 22px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.chat-send:hover { background-color: var(--brand-success-hover); border-color: var(--brand-success-hover); transform: scale(1.05); }

.reply-preview-wrapper {
    background-color: var(--bs-light); border-radius: 12px; padding: 8px 12px;
    display: flex; align-items: center; justify-content: space-between; gap: 8px;
    margin: 0 56px 8px 56px; border-left: 4px solid var(--bs-success); cursor: pointer;
}
[data-bs-theme="light"] .reply-preview-wrapper { background-color: var(--bs-white); }
.reply-preview-wrapper.edit-preview { border-left-color: var(--bs-warning); }
.reply-preview-wrapper.edit-preview .reply-icon, .reply-preview-wrapper.edit-preview .reply-owner { color: var(--bs-warning); }
.reply-content { display: flex; align-items: center; gap: 10px; overflow: hidden; }
.reply-icon { font-size: 20px; color: var(--bs-success); }
.reply-text { overflow: hidden; }
.reply-owner { font-weight: 600; color: var(--bs-success); font-size: 14px; }
.reply-snippet { font-size: 14px; color: var(--bs-text-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.btn-close-reply { width: 32px; height: 32px; font-size: 20px; }

/* Resposta em particular: mesma prévia, com a cor de destaque da marca para não se
   confundir com a resposta comum (verde) nem com a edição (amarelo). Sem clique: a
   mensagem citada mora no grupo, não nesta conversa. */
.reply-preview-wrapper.private-reply-preview { border-left-color: var(--bs-primary); cursor: default; }
.private-reply-preview .reply-icon,
.private-reply-preview .reply-owner { color: var(--bs-primary); }
.private-reply-preview .reply-content { flex: 1 1 auto; min-width: 0; }
.private-reply-preview .reply-text { min-width: 0; }
.private-reply-header { display: flex; align-items: center; gap: 6px; min-width: 0; }
.private-reply-header .reply-owner { flex: 0 1 auto; min-width: 0; }
.private-reply-origin {
    display: inline-flex; align-items: center; gap: 4px; flex: 0 1 auto; min-width: 0; max-width: 55%;
    padding: 1px 8px; border-radius: 999px; font-size: 11px; font-weight: 500; line-height: 18px;
    color: var(--bs-secondary-color); background-color: var(--bs-tertiary-bg);
}
.private-reply-origin i { font-size: 12px; flex-shrink: 0; }
.private-reply-hint { font-size: 14px; color: var(--bs-secondary-color); flex-shrink: 0; cursor: help; border-radius: 50%; }
.private-reply-hint:focus-visible { outline: 2px solid var(--bs-focus-ring-color); outline-offset: 1px; }

/* Em tela de celular as margens laterais de 56px comiam metade da largura da prévia. */
@media (max-width: 575.98px) {
    .reply-preview-wrapper { margin: 0 8px 8px 8px; }
}

.forward-bar { padding: 0 8px; align-items: center; justify-content: space-between; width: 100%; min-height: 50px; }
.cancel-forward-btn { width: 40px; height: 40px; font-size: 24px; background: transparent; }
.forward-count { font-size: 1.1rem; font-weight: 500; color: var(--bs-dark); }
.forward-actions { display: flex; gap: 12px; }
.action-btn { width: 40px; height: 40px; font-size: 20px; color: var(--bs-text-muted); }
.action-btn:hover { background-color: var(--bs-white); color: var(--bs-primary); transform: scale(1.1); }

.signature-btn {
    position: relative;
    margin-right: 4px;
    transition: all 0.2s ease;
}

.signature-btn.active {
    color: var(--bs-primary);
    background-color: rgba(var(--bs-primary-rgb), 0.1);
}

.emoji-dropdown-wrapper {
    margin-right: 2px;
}

textarea.form-control {
    padding-left: 85px !important;
}

textarea.form-control.no-signature {
    padding-left: 45px !important; /* Ajuste conforme o tamanho do botão de emoji restante */
}


.emoji-dropdown-wrapper {
    position: absolute !important;
    left: 4px;
    bottom: 4px;
    z-index: 3;
}
.signature-btn {
    position: absolute !important;
    left: 44px;
    bottom: 4px;
    z-index: 3;
}

/* Aviso de número sem conta no WhatsApp: laranja (alerta, não erro) e fechável */
.sem-conta-aviso {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0 8px 8px;
    padding: 8px 12px;
    border-radius: 10px;
    background: rgba(253, 126, 20, 0.12);
    background: color-mix(in srgb, var(--bs-orange, #fd7e14) 12%, transparent);
    border: 1px solid var(--bs-orange, #fd7e14);
}

.sem-conta-icone {
    color: var(--bs-orange, #fd7e14);
    font-size: 20px;
    flex-shrink: 0;
}

.sem-conta-texto {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    font-size: 13px;
}

.sem-conta-texto strong {
    color: var(--bs-orange, #fd7e14);
}

.sem-conta-texto span {
    color: var(--bs-text-muted);
}

.sem-conta-fechar {
    color: var(--bs-text-muted);
    flex-shrink: 0;
}

/* Estilo para o aviso de Inbox Desconectada */
.offline-status-container {
    background: rgba(239, 71, 111, 0.1);
    border: 2px dashed #ef476f;
    border-radius: 12px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 0 8px;
}

.offline-status-container:hover {
    background: rgba(239, 71, 111, 0.15);
    transform: translateY(-2px);
    border-style: solid;
}

.offline-content {
    display: flex;
    align-items: center;
    gap: 15px;
}

.offline-icon-pulse {
    width: 45px;
    height: 45px;
    background-color: #ef476f;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    animation: pulse-red 2s infinite;

    flex-shrink: 0;
}

.offline-text {
    display: flex;
    flex-direction: column;
}

.offline-text strong {
    color: #ef476f;
    font-size: 16px;
}

.offline-text span {
    font-size: 13px;
    color: var(--bs-text-muted);
}

.btn-reconnect {
    background-color: #ef476f;
    color: white;
    border-radius: 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s;

    flex-shrink: 0 !important;
    white-space: nowrap !important;
}

.btn-reconnect:hover {
    background-color: #d63d60;
    color: white;
}

@keyframes pulse-red {
    0% { box-shadow: 0 0 0 0 rgba(239, 71, 111, 0.7); }
    70% { box-shadow: 0 0 0 10px rgba(239, 71, 111, 0); }
    100% { box-shadow: 0 0 0 0 rgba(239, 71, 111, 0); }
}

/** Estilos para quando o chat está controlado por IA */
.ai-status-container {
    background: #d947ef1a;
    border: 2px dashed #d947ef;
    border-radius: 12px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 0 8px;
}

.ai-status-container:hover {
    background: #d947ef26;
    transform: translateY(-2px);
    border-style: solid;
}

/*
   Sem `inbox.interromper_fluxo_automatizado`: o aviso continua legivel (o
   atendente precisa saber que a IA conduz o chat), mas apagado e inerte.
   `pointer-events: none` cobre o container E o botao de uma vez, e mata junto
   o hover que sugeriria clique. O seletor repete `.is-bloqueado` no par com
   `:hover` para vencer o `.ai-status-container:hover` acima por especificidade,
   e nao por ordem.
*/
.ai-status-container.is-bloqueado,
.ai-status-container.is-bloqueado:hover {
    opacity: 0.55;
    filter: grayscale(0.35);
    cursor: not-allowed;
    pointer-events: none;
    background: #d947ef1a;
    transform: none;
    border-style: dashed;
}

/* A pulsacao do icone chama para uma acao que nao existe mais neste estado. */
.ai-status-container.is-bloqueado .ai-icon-pulse {
    animation: none;
}

.ai-content {
    display: flex;
    align-items: center;
    gap: 15px;
}

.ai-icon-pulse {
    width: 45px;
    height: 45px;
    background-color: #d947ef;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    animation: pulse-ai 2s infinite;

    flex-shrink: 0;
}

.ai-text {
    display: flex;
    flex-direction: column;
}

.ai-text strong {
    color: #d947ef;
    font-size: 16px;
}

.ai-text span {
    font-size: 13px;
    color: var(--bs-text-muted);
}

.btn-interrupt {
    background-color: #d947ef;
    color: white;
    border-radius: 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s;

    flex-shrink: 0 !important;
    white-space: nowrap !important;
}

.btn-interrupt:hover {
    background-color: #cb43e0;
    color: white;
}

.btn-interrupt:disabled {
    background-color: #cb43e0d2;
    color: white;
}

@keyframes pulse-ai {
    0% { box-shadow: 0 0 0 0 #d947efb3; }
    70% { box-shadow: 0 0 0 10px #d948ef00; }
    100% { box-shadow: 0 0 0 0 #d947ef00; }
}

/** Estilos para quando o chat está controlado por bot normal */
.bot-status-container {
    background: #50a5f11a;
    border: 2px dashed #50a5f1;
    border-radius: 12px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 0 8px;
}

.bot-status-container:hover {
    background: #50a5f126;
    transform: translateY(-2px);
    border-style: solid;
}

.bot-content {
    display: flex;
    align-items: center;
    gap: 15px;
}

.bot-icon-pulse {
    width: 45px;
    height: 45px;
    background-color: #50a5f1;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    animation: pulse-bot 2s infinite;
    flex-shrink: 0;
}

.bot-text {
    display: flex;
    flex-direction: column;
}

.bot-text strong {
    color: #50a5f1;
    font-size: 16px;
}

.bot-text span {
    font-size: 13px;
    color: var(--bs-text-muted);
}

.btn-start-attendance {
    background-color: #50a5f1;
    color: white;
    border-radius: 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s;
    flex-shrink: 0 !important;
    white-space: nowrap !important;
}

.btn-start-attendance:hover {
    background-color: #3d92de;
    color: white;
}

.btn-start-attendance:disabled {
    background-color: #3d92ded2;
    color: white;
}

@keyframes pulse-bot {
    0% { box-shadow: 0 0 0 0 #50a5f1b3; }
    70% { box-shadow: 0 0 0 10px #50a5f100; }
    100% { box-shadow: 0 0 0 0 #50a5f100; }
}

/** Estilos para quando o usuário tá vendo o chat mas o atendimento não tá aberto */
/* @property --ciobaino-color     { initial-value: #06D6A0; }
@property --ciobaino-bg        { initial-value: #06D6A01a; }
@property --ciobaino-bg-hover  { initial-value: #06D6A026; }
@property --ciobaino-btn-hover { initial-value: #08af82; }
@property --ciobaino-pulse-0   { initial-value: #06D6A0b3; }
@property --ciobaino-pulse-70  { initial-value: #06D6A000; }
@property --ciobaino-pulse-100 { initial-value: #06D6A000; } */

.ciobaino-status-container {
    background: rgba(var(--bs-success-rgb), 0.10);
    border: 2px dashed var(--bs-success);
    border-radius: 12px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
    margin: 0 8px;
}

.ciobaino-status-container:hover {
    background: rgba(var(--bs-success-rgb), 0.15);
    transform: translateY(-2px);
    border-style: solid;
}

.ciobaino-content {
    display: flex;
    align-items: center;
    gap: 15px;
}

.ciobaino-icon-pulse {
    width: 45px;
    height: 45px;
    background-color: var(--bs-success);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    animation: pulse-ciobaino 2s infinite;

    flex-shrink: 0;
}

.ciobaino-text {
    display: flex;
    flex-direction: column;
}

.ciobaino-text strong {
    color: var(--bs-success);
    font-size: 16px;
}

.ciobaino-text span {
    font-size: 13px;
    color: var(--bs-text-muted);
}

.btn-open {
    background-color: var(--bs-success);
    color: white;
    border-radius: 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s;

    flex-shrink: 0 !important;
    white-space: nowrap !important;
}

.btn-open:hover {
    background-color: var(--brand-success-hover);
    color: white;
}

.btn-open:disabled {
    background-color: color-mix(in srgb, var(--brand-success-hover) 82%, transparent);
    color: white;
}

@keyframes pulse-ciobaino {
    0% { box-shadow: 0 0 0 0 rgba(var(--bs-success-rgb), 0.70); }
    70% { box-shadow: 0 0 0 10px rgba(var(--bs-success-rgb), 0); }
    100% { box-shadow: 0 0 0 0 rgba(var(--bs-success-rgb), 0); }
}


.spin {
    display: block;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.mention-dropdown-container {
    position: absolute;
    bottom: 100%; /* Acima do input */
    left: 12px;
    margin-bottom: 8px;
    width: 280px;
    background: var(--bs-white);
    border-radius: 12px;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.15);
    z-index: 1000;
    overflow: hidden;
    border: 1px solid var(--bs-border-color);
}

[data-bs-theme="dark"] .mention-dropdown-container {
    background: #2a2d31;
    border-color: rgba(255,255,255,0.1);
}

.mention-list {
    max-height: 250px;
    overflow-y: auto;
}

.mention-item {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    cursor: pointer;
    transition: background 0.2s;
    border-bottom: 1px solid rgba(0,0,0,0.03);
}

.mention-item:last-child { border-bottom: none; }

.mention-item:hover, .mention-item.active {
    background-color: rgba(var(--bs-success-rgb), 0.1);
}

.mention-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 12px;
    background: #e0f2f1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.mention-avatar img { width: 100%; height: 100%; object-fit: cover; }
.mention-avatar .initials { font-size: 12px; font-weight: 700; color: var(--bs-success); }

.mention-info {
    display: flex;
    flex-direction: column;
}

.mention-name {
    font-size: 14px;
    font-weight: 600;
    color: var(--bs-body-color);
}

.mention-phone {
    font-size: 11px;
    color: var(--bs-text-muted);
}

.mention-empty {
    padding: 15px;
    text-align: center;
    font-size: 13px;
    color: var(--bs-text-muted);
}

.reply-media-content-preview {
    /* max-width: 80px; */
    height: 65px;
    border-radius: 0 8px 8px 0;
}
</style>
